/** @format */
import { Attainment, OtmId } from 'common-typescript/types';
import { PlanData } from './plan-state.service';

/**
 * Finds an attainment of the plan by its id, typed by the given type guard. Gives `undefined` when the plan has no such attainment, or
 * when the attainment is of another type.
 */
export function getAttainmentFromPlanData<A extends Attainment>(
    planData: PlanData,
    attainmentId: OtmId,
    isOfType: (attainment: Attainment) => attainment is A,
): A | undefined {
    const attainment = planData.attainmentsById[attainmentId];
    return isOfType(attainment) ? attainment : undefined;
}
